import * as React from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane, Button } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, existFactsByFundGroup, FactTable, generateLocalStateFromEventProperties, getSelectedAfr, getTable, saveDocumentRelationship, updateVersionStateValue } from '../../redux/AfrSlice';
import { resetConceptState } from "../../redux/ConceptSlice";
import { DocumentRelationship, uploadFile } from '../../redux/DocumentsSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { isAdmin, setIsDirty } from '../../redux/MiscSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import BalanceSheetForFundsCoreWrapper from '../AfrCore/BalanceSheetForFundsCoreWrapper';
import ExpendituresCoreDetail from '../AfrCore/ExpendituresCoreDetail';
import RevenuesCoreDetail from '../AfrCore/RevenuesCoreDetail';
import RevenuesCoreImpactFees from '../AfrCore/RevenuesCoreImpactFees';
import AfrFilingInstructionsModal from '../layout/Modal/AfrFilingInstructionsModal';
import Page from '../Page';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';
const AccountsByFundGroupCore = (props: { userRole: string, fundGroup: string, noData: string, done: string, reviewed: string }) => {
    const dispatch = useAppDispatch();
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);
    /* Tabs logic */
    const [activeTab, setActiveTab] = useState("1");
    const [revenueDocumentation, setRevenueDocumentation] = useState<string[]>([]);
    const isAdminUser: boolean = useAppSelector(isAdmin);
    const parameters = useLocation();


    const [fileName, setFileName] = useState("");
    const [pdfDocumentId, setPdfDocumentId] = useState("");
    const [modalInstructionsIsOpen, setModalInstructionsIsOpen] = useState(false);
    const handleCloseInstructionsModal = function () {
        setModalInstructionsIsOpen(false);
    }
    const openInstructionsModal = function () {
        setModalInstructionsIsOpen(true);
    }
    // reference to input type file
    const openFileRef = React.useRef<any>();

    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const [hasFacts, setHasFacts] = useState(existFactsByFundGroup(currentAfr, ["uas_006_balance-sheet", "uas_020_revenue", "uas_020_revenue_dwellings_and_fees", "uas_034_expenditures",], props.fundGroup));
    const [state, setState] = useState(generateLocalStateFromEventProperties(currentAfr, [props.done, props.noData, props.reviewed]));

    var settings = {
        upload: { legend: "", entityType: "AFFIDAVIT", actionType: "UPLOAD_PDF", checkboxLegend: "", cardTitle: "Affidavit PDF", successfulUploadMessage: "Affidavit Uploaded Successfully!" },
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }
    const updateHasFacts = function (bHasFacts: boolean) {
        if (bHasFacts) {
            setHasFacts(true);
            return;
        }
        if (currentAfr) {
            setHasFacts(existFactsByFundGroup(currentAfr, ["uas_006_balance-sheet", "uas_020_revenue", "uas_020_revenue_dwellings_and_fees", "uas_034_expenditures"], props.fundGroup));
        } else {
            setHasFacts(false);
        }
    }

    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;

        //if they uncheck no data, we need to uncheck the done check box
        if (key === props.noData && value === false) {
            checkValues[props.done] = false;
            // Update global flag for this event in redux
            var eventFirstLevelDone = props.done.split("_")[0];
            var eventSecondLevelDone = props.done.split("_")[1];
            dispatch(updateVersionStateValue({ propGroup: eventFirstLevelDone, propName: eventSecondLevelDone, boolValue: false, value: null }));
        }

        setState(checkValues);

        // call to dispatcher by sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]


        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))
    }
    const getFundGroupSubtableTitle = function (fg: string, tableTitle: string): string {
        var result: string = tableTitle;
        switch (fg) {
            case "Fiduciary":
                switch (tableTitle) {
                    case "Revenues":
                        result = "Additions";
                        break;
                    case "Expenditures":
                        result = "Deductions";
                        break;
                }
                break;
            case "Proprietary":
                switch (tableTitle) {
                    case "Revenues":
                        result = "Operating and Non-Operating Revenues";
                        break;
                    case "Expenditures":
                        result = "Operating and Non-Operating Expenditures";
                        break;
                }
                break;
            
        }
        return result;
    }
    return (
        <React.Fragment>
            <Page>
                <h2>{utilityHelper.getFundGroupTitle(props.fundGroup)} for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h2>
                <Row>
                    <Col>
                        <Row>
                            <Col>
                                <div className="box-events pl-2 pr-3 py-3 my-2">
                                    <div>
                                        <Label className="ml-4" check>
                                            <Input type="checkbox"
                                                name={props.noData}
                                                onChange={handleChangeCheckbox}
                                                disabled={hasFacts || utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                checked={state[props.noData] && state[props.noData] == true ? true : false}
                                            />{' '} <b>No {props.fundGroup} Funds</b>
                                        </Label>
                                        <Label className="ml-5" check>
                                            <Input type="checkbox"
                                                name={props.done}
                                                onChange={handleChangeCheckbox}
                                                disabled={!(hasFacts || (state[props.noData] ? true : false)) ||
                                                    (state[props.done] ? utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified) : false)
                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin) }
                                                checked={state[props.done] && state[props.done] == true ? true : false}
                                            />{' '} <b>Done</b>
                                        </Label>
                                        {isAdminUser && (
                                            <Label className="ml-5" check>
                                                <Input type="checkbox"
                                                    name={props.reviewed}
                                                    onChange={handleChangeCheckbox}
                                                    checked={state[props.reviewed] && state[props.reviewed] == true ? true : false}
                                                    disabled={!utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)}
                                                /><b>Reviewed</b>
                                            </Label>)}
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <Button className="box-events" style={{color:"Black"}} type="button" onClick={openInstructionsModal}>Click Here for<br />Instructions</Button>
                            </Col>
                        </Row>
                        <div>
                            <Nav tabs>
                                {utilityHelper.showTab(currentAfr, enums.tableName.balancesheet) &&
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('1')}
                                            onClick={() => { toggle('1'); }}
                                        >
                                            {getFundGroupSubtableTitle(props.fundGroup, "Balance Sheet")}
                                        </NavLink>
                                    </NavItem>}

                                {utilityHelper.showTab(currentAfr, enums.tableName.revenues) &&
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('2')}
                                            onClick={() => { toggle('2'); }}
                                        >
                                            {getFundGroupSubtableTitle(props.fundGroup, "Revenues")}   
                                        </NavLink>
                                    </NavItem>}
                                {utilityHelper.showTab(currentAfr, enums.tableName.impactfees) &&
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('3')}
                                            onClick={() => { toggle('3'); }}
                                        >
                                            {getFundGroupSubtableTitle(props.fundGroup, "Impact Fees")}
                                        </NavLink>
                                    </NavItem>}
                                {utilityHelper.showTab(currentAfr, enums.tableName.expenditures) &&
                                    <NavItem>
                                        <NavLink
                                            className={activeClass('4')}
                                            onClick={() => { toggle('4'); }}
                                        >
                                            {getFundGroupSubtableTitle(props.fundGroup, "Expenditures")}
                                        </NavLink>
                                    </NavItem>}
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "1") &&
                                                (<BalanceSheetForFundsCoreWrapper done={props.done} noData={props.noData} userRole={props.userRole} fundGroup={props.fundGroup} setHasData={updateHasFacts} />)
                                            }
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "2") && (<RevenuesCoreDetail doneFlag={props.done} noFlag={props.noData} setHasData={updateHasFacts} fundGroup={props.fundGroup} />)}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="3">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "3") && (<RevenuesCoreImpactFees doneFlag={props.done} noFlag={props.noData} setHasData={updateHasFacts} fundGroup={props.fundGroup} />)}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="4">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "4") && (<ExpendituresCoreDetail doneFlag={props.done} noFlag={props.noData} setHasData={updateHasFacts} fundGroup={props.fundGroup} />)}
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>

                    </Col>
                </Row>
                {currentAfr && (<AfrFilingInstructionsModal
                    source="FG_TotalFundGroupsMember"
                    isOpen={modalInstructionsIsOpen}
                    fundGroup={props.fundGroup}
                    onCloseModal={handleCloseInstructionsModal} />)}
            </Page>
        </React.Fragment>
    );

}
export default AccountsByFundGroupCore;